const FrontPage = ({ data }) => {
    return (
        <>
            <div className='FrontPage__Screen__Background'>
                {data?.isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage__Screen__Background__Image' />
                ) : (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='FrontPage__Screen__Background__Image' />
                )}
            </div>

            <div className="FrontPage__Screen__Container">
                <img src='/img/page/adsl-five.png' className='FrontPage__Screen__Container__Logo' />

                <p className="FrontPage__Screen__Container__Title">HAZLE LA LUCHA</p> {/* Fonts--RoughStroke */}

                <div className="FrontPage__Screen__Container__Players">
                    <img src="/img/games/quizz/wrestling/lucho.png" className="FrontPage__Screen__Container__Players__Image" />
                    <img src="/img/games/quizz/wrestling/tuna.png" className="FrontPage__Screen__Container__Players__Image" />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { FrontPage };